import { render } from "./index.vue?vue&type=template&id=1957ce7c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1957ce7c&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\21-century-edm-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__